import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    padding: 12px;
`;

const TimeDisplay = styled.p`
    margin: 0;
`;

type ScheduleExpression =
    | { type: 'OneTimeSchedule'; dateTime: string }
    | { type: 'RecurringRateBasedSchedule'; unit: string; value: number }
    | { type: 'RecurringCronBasedSchedule'; cronExpression: string };

function formatRecurringRateBasedSchedule(schedule: { unit: string; value: number }): string {
    return `Every ${schedule.value} ${schedule.unit.toLowerCase()}${schedule.value > 1 ? 's' : ''}`;
}

interface ScheduleEditorProps {
    nodeState: Record<string, any>;
    setNodeState: (key: string, value: any) => void;
}

export const ScheduleEditor: React.FC<ScheduleEditorProps> = ({ nodeState }) => {
    const time: ScheduleExpression = nodeState.time || { type: 'RecurringRateBasedSchedule', unit: 'DAY', value: 1 };

    function renderValue() {
        switch (time.type) {
            case 'OneTimeSchedule': {
                const offset = new Date().getTimezoneOffset() * 60000;
                const localDateTime = new Date(new Date(time.dateTime).getTime() - offset);
                return <TimeDisplay>At {localDateTime.toLocaleString()}</TimeDisplay>;
            }

            case 'RecurringRateBasedSchedule': {
                return <TimeDisplay>{formatRecurringRateBasedSchedule(time)}</TimeDisplay>;
            }

            case 'RecurringCronBasedSchedule': {
                return <TimeDisplay>Cron: {time.cronExpression}</TimeDisplay>;
            }
        }
    }

    return <Container>{renderValue()}</Container>;
};
